import React from 'react';
import { useIFCStore } from '../../../apps/bim-catastro/stores';
import './LoadingModal.css';

const LoadingModal: React.FC = () => {
	const { isLoading } = useIFCStore();

	if (!isLoading) return null;

	return (
		<div className="v2-loading-modal-overlay">
			<div className="v2-loading-modal">
				<div className="v2-spinner" />
				<div className="v2-loading-text">Cargando IFC…</div>
			</div>
		</div>
	);
};

export default LoadingModal;


